import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.scss'],
    standalone: false
})
export class PaymentSuccessComponent implements OnInit {

  constructor(private router: Router, private sharedService: SharedService) { }

  ngOnInit(): void {
    window.opener.location.href = '/mycart/order-confirmation'
    window.opener.focus()
    window.top.close();
    this.miniCartDetails();
  }

  miniCartDetails() {
    this.sharedService.getminiCart()
      .subscribe(
        response => {
        }
      );
  }

}
